import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { useAuth } from './stores/auth';
import './styles/main.css';

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());

  // Playwright smoke tests set __HOAWATCH_TEST__ via addInitScript and inject
  // auth state directly via __auth.__setTestSession — skip MSAL in that path.
  const isTest = (window as unknown as { __HOAWATCH_TEST__?: boolean }).__HOAWATCH_TEST__ === true;

  // Anonymous public-portal routes (and the SPA subdomain entry) must not run
  // MSAL — there's no signed-in user and MSAL.handleRedirectPromise can throw
  // BrowserAuthError when it sees no pending redirect on a non-auth path.
  const path = window.location.pathname;
  const host = window.location.host;
  const isAnonymousPortal =
    path.startsWith('/portal/') ||
    /^(?!app\.|www\.|api\.)[a-z0-9-]+\.hoawatch\.com$/i.test(host);

  // hydrate() initialises MSAL, handles any pending redirect, then calls /v1/me.
  const auth = useAuth();
  if (!isTest && !isAnonymousPortal) {
    await auth.hydrate();
  } else if (isTest) {
    // Expose the store and router on window so the smoke test can inject a session
    // and navigate without causing a full page reload.
    (window as unknown as { __auth: typeof auth }).__auth = auth;
    (window as unknown as { __router: typeof router }).__router = router;
  }

  app.use(router);
  await router.isReady();
  app.mount('#app');
}

bootstrap().catch((err) => {
  console.error('[bootstrap] failed', err);
  document.body.innerText = 'Failed to start HOA Watch. Check the console.';
});
